exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line-replace[data-v-5008ad0a]{position:absolute;left:0;z-index:-1;width:100%;height:4px;background:0 0/100% 100% no-repeat}.component[data-v-5008ad0a]{width:100%;height:100%;position:relative;z-index:0}.img[data-v-5008ad0a]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;margin:0 auto;max-width:100%;min-width:100%;background:0 0/100% 100% no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5008ad0a","scoped":true,"sourceMap":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/index.vue
// module id = 20
// module chunks = 1